<template>
    <div class="flex flex-wrap">
        <div class="w-full lg:w-1/2">
            <div class="p-4 md:m-4 md:border md:rounded md:shadow">
                <graph-bar-horizontal
                    chart_id="active_covers"
                    :title="$t('dashboard.graph_title.active_covers')"
                    dataset_endpoint="/api/dashboard/graphs/active_covers"
                    :filter_params="filter_params"
                    :filter_limit="6"
                    default_sub_filter="insurer"
                    :sub_filter_options="active_covers_filter_options"
                    :view_more="true"
                    :view_more_title="$t('dashboard.view_more_title.active_covers')"
                    :view_more_limit="10"
                    @viewMoreInfo="handleViewMore"
                />
            </div>
        </div>
        <div class="w-full md:w-1/2">
            <div class="p-4 md:m-4 md:border md:rounded md:shadow">
                <graph-bar-vertical
                    chart_id="query_executed"
                    :title="$t('dashboard.graph_title.query_executed')"
                    dataset_endpoint="/api/dashboard/graphs/query_executed_cover"
                    :filter_params="filter_params"
                    :filter_limit="6"
                    default_sub_filter="insurer"
                    :sub_filter_options="query_executed_cover_filter_options"
                    :view_more="true"
                    :view_more_title="$t('dashboard.view_more_title.query_executed')"
                    :view_more_limit="10"
                    @viewMoreInfo="handleViewMore"
                />
            </div>
        </div>
        <div class="w-full md:w-1/2">
            <div class="p-4 md:m-4 md:border md:rounded md:shadow">
                <graph-doughnut
                    chart_id="cover_source_insurer"
                    :title="$t('dashboard.graph_title.cover_source_insurer')"
                    dataset_endpoint="/api/dashboard/graphs/cover_source_insurer"
                    :filter_params="filter_params"
                    default_sub_filter="certificate"
                    :sub_filter_options="cover_source_filter_options"
                />
            </div>
        </div>
        <div class="w-full md:w-1/2">
            <div class="p-4 md:m-4 md:border md:rounded md:shadow">
                <graph-doughnut
                    chart_id="cover_source_intermediary"
                    :title="$t('dashboard.graph_title.cover_source_intermediary')"
                    dataset_endpoint="/api/dashboard/graphs/cover_source_intermediary"
                    :filter_params="filter_params"
                    default_sub_filter="certificate"
                    :sub_filter_options="cover_source_filter_options"
                />
            </div>
        </div>
        <div class="w-full md:w-1/2">
            <div class="p-4 md:m-4 md:border md:rounded md:shadow">
                <graph-doughnut
                    chart_id="cover_category_insurer"
                    :title="$t('dashboard.graph_title.cover_category_insurer')"
                    dataset_endpoint="/api/dashboard/graphs/cover_category_insurer"
                    :filter_params="filter_params"
                    default_sub_filter="comprehensive"
                    :sub_filter_options="cover_category_filter_options"
                />
            </div>
        </div>
        <div class="w-full md:w-1/2">
            <div class="p-4 md:m-4 md:border md:rounded md:shadow">
                <graph-doughnut
                    chart_id="cover_category_intermediary"
                    :title="$t('dashboard.graph_title.cover_category_intermediary')"
                    dataset_endpoint="/api/dashboard/graphs/cover_category_intermediary"
                    :filter_params="filter_params"
                    default_sub_filter="comprehensive"
                    :sub_filter_options="cover_category_filter_options"
                />
            </div>
        </div>
        <div class="w-full md:w-1/2">
            <div class="p-4 md:m-4 md:border md:rounded md:shadow">
                <graph-bar-horizontal
                    chart_id="cover_upload_frequency"
                    :title="$t('dashboard.graph_title.upload_frequency')"
                    dataset_endpoint="/api/dashboard/graphs/upload_frequency_cover"
                    :filter_params="filter_params"
                    :filter_limit="6"
                    default_sub_filter="count"
                    :sub_filter_options="upload_frequency_filter_options"
                    :view_more="true"
                    :view_more_title="$t('dashboard.view_more_title.upload_frequency')"
                    :view_more_limit="10"
                    @viewMoreInfo="handleViewMore"
                />
            </div>
        </div>
    </div>
</template>

<script>
import GraphBarHorizontal from '@/components/graphs/BarHorizontal.vue';
import GraphBarVertical from '@/components/graphs/BarVertical.vue';
import GraphDoughnut from '@/components/graphs/Doughnut.vue';

export default {
    components: {
        GraphBarHorizontal,
        GraphBarVertical,
        GraphDoughnut,
    },
    props: {
        filter_params: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            active_covers_filter_options: [
                {
                    value: 'insurer',
                    text: this.$t('dashboard.filter_options.active_covers.insurer'),
                },
                {
                    value: 'intermediaries',
                    text: this.$t('dashboard.filter_options.active_covers.intermediaries'),
                },
                {
                    value: 'cover_type',
                    text: this.$t('dashboard.filter_options.active_covers.cover_type'),
                },
            ],
            query_executed_cover_filter_options: [
                {
                    value: 'insurer',
                    text: this.$t('dashboard.filter_options.query_executed.insurer'),
                },
                {
                    value: 'intermediaries',
                    text: this.$t('dashboard.filter_options.query_executed.intermediaries'),
                },
                {
                    value: 'users',
                    text: this.$t('dashboard.filter_options.query_executed.users'),
                },
            ],
            cover_source_filter_options: [
                {
                    value: 'certificate',
                    text: this.$t('dashboard.filter_options.cover_source.certificate'),
                },
                {
                    value: 'covernote',
                    text: this.$t('dashboard.filter_options.cover_source.covernote'),
                },
            ],
            cover_category_filter_options: [
                {
                    value: 'comprehensive',
                    text: this.$t('dashboard.filter_options.cover_category.comprehensive'),
                },
                {
                    value: 'third_party',
                    text: this.$t('dashboard.filter_options.cover_category.third_party'),
                },
                {
                    value: 'act',
                    text: this.$t('dashboard.filter_options.cover_category.act'),
                },
            ],
            upload_frequency_filter_options: [
                {
                    value: 'count',
                    text: this.$t('dashboard.filter_options.frequency.count'),
                },
                {
                    value: 'record',
                    text: this.$t('dashboard.filter_options.frequency.record'),
                },
            ],
        };
    },
    methods: {
        handleViewMore(data) {
            this.$emit('viewMoreInfo', data);
        },
    },
};
</script>
